import GuestListActions from '../../actions/GuestListActions';
import UserActions from '../../actions/UserActions';
import PosActions from '../../actions/PosActions';

import UserStore from '../../stores/UserStore';
import PosStore from '../../stores/PosStore';
import GuestListStore from '../../stores/GuestListStore';

import Guest from './Guest.react';

var timer;

class GLStatus extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            visible : false,
        };
    }


    render() {
        var rooms = this.props.rooms,
            statusList = this.props.statusList.map(x => {
                return x.POSStatus;
            }),
            selectedRoomArr = this.props.selectedRoomArr,
            location = this.props.location,
            guestList = this.props.guestList;

        var roomList = rooms.map(x => {
            return x.RoomName;
        });

        var arr = statusList;

        var cssPrefix = 'gl-select--right';

        return (
            <div className={cssPrefix}>
                <div
                    className={cssPrefix + '__title'}
                    onClick={() => { this.setState({ visible : !this.state.visible }) }}>

                    {'Status'}

                    <i className={'fa fa-angle-double-'+(this.state.visible ? 'up' : 'down')} />
                </div>

                { this.state.visible &&
                    <div className={cssPrefix + '__content'}>
                        <div
                            id='all'>

                            <input
                                type='checkbox'
                                onChange={() => { UserActions.clearGuestListFilterArr(); }}
                                checked={selectedRoomArr.length === 0} />

                            <label
                                for='all'
                                onClick={() => { UserActions.clearGuestListFilterArr(); }}>

                                ALL
                            </label>
                        </div>

                        { arr.map((status, i) => {
                            var checked = selectedRoomArr.indexOf(status) !== -1 ? true : false;
                            var count = guestList.filter(x => {

                                return x.TransactionStatus === status
                                
                            } ).length;

                            return (
                                <div
                                    id={status}
                                    key={status}>

                                    <input
                                        type='checkbox'
                                        onChange={() => { UserActions.selectGuestListFilterArr(status); }}
                                        checked={checked} />

                                    <label
                                        for={status}
                                        onClick={() => { UserActions.selectGuestListFilterArr(status); }}>

                                        {status}
                                    </label>

                                    <span style={{'float':'right'}}>{count}</span>
                                </div>
                            );
                        })}
                    </div>
                }
            </div>
        );
    }
}

export default GLStatus;



// WEBPACK FOOTER //
// ./ui_src/app/components/guest-list/GLStatus.react.jsx